import { SiStatuspal } from "react-icons/si";
import { GrDomain } from "react-icons/gr";
import StatusItem from "../StatusItem";
import UpdateSiteStatusForm from "../Forms/UpdateSiteStatusForm";
import UpdateAppStatusForm from "../Forms/UpdateAppStatusForm";
import { useSiteState } from "../../utils/useSiteState";
import { createDocsUrl } from "../../utils/urls";

const SiteEditSidebar: React.FC = () => {
  const { site, reload: updateSite } = useSiteState();

  return (
    <div className="h-screen p-5 text-white">
      <StatusItem
        Icon={SiStatuspal}
        text="Site Status"
        value={site.published ? "Published" : "Draft"}
        field={(onComplete) => (
          <UpdateSiteStatusForm
            site={site}
            onComplete={async () => {
              await updateSite();
              onComplete();
            }}
          />
        )}
      />

      <StatusItem
        Icon={SiStatuspal}
        text="App Status"
        value={site.is_coming_soon ? "Coming Soon" : "Live"}
        field={(onComplete) => (
          <UpdateAppStatusForm
            site={site}
            onComplete={async () => {
              await updateSite();
              onComplete();
            }}
          />
        )}
      />
      <hr />
      <div className="my-4 items-center">
        <p className="mr-2 font-medium flex items-center">
          <GrDomain className="mr-2" /> Domains:
        </p>{" "}
        <a
          href={`https://${createDocsUrl(site)}`}
          target="_blank"
          rel="noreferrer"
          className="block my-1 font-medium text-red-600"
        >
          {createDocsUrl(site)}
        </a>
        {site.custom_domain && (
          <a
            href={`https://${site.custom_domain}`}
            target="_blank"
            rel="noreferrer"
            className="block my-1 font-medium text-red-600"
          >
            {site.custom_domain}
          </a>
        )}
      </div>
      {!site.published && (
        <div className="my-4 items-center">
          <p className="mr-2 font-medium flex items-center">
            <GrDomain className="mr-2" /> Preview URL:
          </p>{" "}
          <a
            href={`https://${createDocsUrl(site)}?preview=${site.preview_token}`}
            target="_blank"
            rel="noreferrer"
            className="block my-1 font-medium text-red-600"
          >
            {createDocsUrl(site)}?preview={site.preview_token}
          </a>
        </div>
      )}
      <hr />
    </div>
  );
};

export default SiteEditSidebar;
